<template>
  <ajax-select
      :label="trans('misc.account')"
      :resource-url="resourceUrl"
      :filter-attributes="attributes"
      :item-text="buildText"
      :value="miscAccountId"
      @update:value="$emit('update:miscAccountId', $event)"
  >

  </ajax-select>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import AjaxSelect from '@/components/AjaxSelect';
import {FilterUtils} from '@/utils/filter-utils';
import {MiscAccountApi} from '@/api/misc-account-api';

export default {
  name: 'SelectMiscAccount',
  components: {AjaxSelect},
  mixins: [
    LocaleUtils,
    FilterUtils
  ],
  props: {
    miscAccountId: {
      default () {
        return null;
      }
    }
  },
  computed: {
    attributes() {
      return ['accountNbr', 'description'];
    },
    resourceUrl () {
      return MiscAccountApi.apiUri;
    }
  },
  methods: {
    buildText(miscAccount) {
      return miscAccount.description + ' (' + miscAccount.accountNbr + ')';
    }
  }
}
</script>
